<div class="nlf-card--dropdown" [ngClass]="{ 'nlf-card--dropdown--open': dropdownService.isOpen('loginDropdown') }">
	<div class="nlf-card">
		<div class="nlf-card__header nlf-card__header--exit">
			<div class="nlf-card__header-content">
				<h2 class="nlf-title--xs" id="modal__title" skeletonLoader [translationKey]="'header.text.logIn'">
          {{'header.text.loginToBenefitFrom' | ibeadmin | async}}
        </h2>
			</div>
			<div class="close-dropdown">
				<button (click)="closeDropdown('loginDropdown')">
					<app-svg svg="icons.svg#general--not_available" [size]="'s'" aria-hidden="true"
						[alt]="'Close icon'"></app-svg>
				</button>
			</div>
		</div>
		<div class="nlf-card__body">
      <ul class="nlf-list nlf-list--svg nlf-body--m">
				<li>
					<strong skeletonLoader [translationKey]="'header.text.discountsWithMiles'">
            <app-svg aria-hidden="true" [size]="'m'" [svg]="'icons.svg#check-in--check-in'"></app-svg>
            {{'header.text.discountsWithMiles' | ibeadmin | async}}
					</strong>
				</li>
				<li>
					<strong skeletonLoader [translationKey]="'header.text.fasterBookingProcess'">
            <app-svg aria-hidden="true" [size]="'m'" [svg]="'icons.svg#check-in--check-in'"></app-svg>
            {{'header.text.fasterBookingProcess' | ibeadmin | async}}
					</strong>
				</li>
				<li>
					<strong skeletonLoader [translationKey]="'header.text.payExtrasAndFlightsWithMiles'">
            <app-svg aria-hidden="true" [size]="'m'" [svg]="'icons.svg#check-in--check-in'"></app-svg>
            {{'header.text.payExtrasAndFlightsWithMiles' | ibeadmin | async}}
					</strong>
				</li>
			</ul>
			<div class="buttons buttons--column">
				<button nlfButton [buttonStyle]="'primary'" [buttonFullWidth]="'all'" (click)="openLoginModal()" skeletonLoader [translationKey]="'header.text.logIn'">
          {{'header.text.logIn' | ibeadmin | async}}
				</button>
				<a nlfButton [buttonStyle]="'outline'" [buttonFullWidth]="'all'" href="https://www.flytap.com/sign-up?RegistrationType=Miles-and-go" target="_blank" skeletonLoader [translationKey]="'header.text.registerIfYouAreNotTAPClient'">
          {{'header.text.registerIfYouAreNotTAPClient' | ibeadmin | async}}
				</a>
			</div>
		</div>
	</div>
</div>
